import React, {useState} from "react";
import {range,map} from 'lodash';
import {makeStyles} from "@material-ui/core/styles";
import SearchableSelect from "../../components/SearchableSelect";


const useStyles = makeStyles({
    formControl:
    {
        minWidth:"75px"
    }

});

export interface ReportDateInputValue
{
    year:number;
    month:number;
}

export const useReportDate = ()=>
{
    const now = new Date();
    const [reportDate,setReportDate] = useState<ReportDateInputValue>({year:now.getFullYear(),month:now.getMonth() + 1});
    const onChange = ({year,month})=>setReportDate({year,month});
    return {reportDate,onChange};
}


export default ({value,onChange}:{value:ReportDateInputValue,onChange:(value:ReportDateInputValue)=>void})=>
{
    const styles = useStyles();

    return <>
        <span className={styles.formControl} style={{display: "inline-block"}}>
            <SearchableSelect
                label={"月"}
                disableClearable
                options={map(range(1, 13), i => ({value: i, label: `${i}`}))}
                value={value.month}
                onChange={month => onChange({...value, month})}
            />
        </span>
        <span className={styles.formControl} style={{display: "inline-block"}}>
            <SearchableSelect
                label={"年"}
                disableClearable
                options={map(range(2021, 2027), i => ({value: i, label: `${i}`}))}
                value={value.year}
                onChange={year => onChange({...value, year})}
            />
        </span>


    </>
}
